import {ReactNode} from 'react';
import {twMerge} from 'tailwind-merge';

import BaseModal, {
  BaseModalProps,
} from '@/shared/components/modals/base/BaseModal';

type ButtonProps = {
  label: ReactNode;
  onClick: () => void;
};

export type DialogModalProps = Omit<
  BaseModalProps,
  'backdropProps' | 'smoothBackdropAnimation'
> & {
  width?: 'small';
  okButton?: ButtonProps;
  cancelButton?: ButtonProps;
  title?: string;
};

export default function DialogModal({
  width = 'small',
  title,
  children,
  okButton,
  cancelButton,
  ...modalProps
}: DialogModalProps) {
  const shouldRenderButtons = Boolean(okButton) || Boolean(cancelButton);

  return (
    <BaseModal {...modalProps} appearSmoothBackdropAnimation>
      <div
        className={twMerge(
          'flex flex-col items-center gap-4 rounded-[10px] bg-white px-6 py-8 text-center text-dark-gray',
          width === 'small' && 'w-[320px]'
        )}
      >
        {title && <h2 className="font-semibold text-black text-lg">{title}</h2>}
        {children}
        {shouldRenderButtons && (
          <div className="mt-4 flex w-full justify-center gap-3">
            {cancelButton && <CancelButton {...cancelButton} />}
            {okButton && <OkButton {...okButton} />}
          </div>
        )}
      </div>
    </BaseModal>
  );
}

function OkButton({label, onClick}: ButtonProps) {
  return (
    <button
      className="basis-[146px] rounded-lg bg-primary py-[6px] font-bold text-lg text-white"
      onClick={onClick}
    >
      {label}
    </button>
  );
}

function CancelButton({label, onClick}: ButtonProps) {
  return (
    <button
      className="basis-[146px] rounded-lg bg-placeholder py-[6px] font-bold text-dark-gray text-lg"
      onClick={onClick}
    >
      {label}
    </button>
  );
}
